export default __webpack_public_path__ + "static/media/HamburgSymbols.f4fbf450.woff2";